
export class Api {
    public static login = 'social/login/web';
    public static temples = 'all/${this.host}'; // temple/pooja/online/${this.host}
    public static poojas = 'temple/pooja';
    public static devotees = 'user/devotees';
    public static person = 'person';
    public static versionCheck = 'version/check';
    public static order = 'online/order/web';
    public static transactions = 'online/user/transactions';
    public static accommodationFeed = 'all/accommodation';
    public static userKyc = 'online/user/kyc';
    public static accommodationOrder = 'online/accommodation/order/web';
    public static accommodationBookings = 'online/accommodation/user/bookings';
    // WS-FHP portal (docs/FUNCTION_HALL_PRIEST_MODULE.md §6.5)
    public static functionHallFeed = 'all/function-hall';
    public static functionHallOrder = 'online/function-hall/order/web';
    public static functionHallBookings = 'online/function-hall/user/bookings';
    /** Base for per-booking devotee actions, e.g. `${functionHallBooking}/{id}/cancel`. */
    public static functionHallBooking = 'online/function-hall/booking';
}
